export function timeout(timeout) {
    return new Promise(resolve => setTimeout(resolve, timeout));
}

/**
 * @param {?PositionOptions} options
 * @returns {Promise<google.maps.LatLngLiteral>}
 */
export function getCurrentPosition(options = null) {
    return new Promise((resolve, reject) => window.navigator.geolocation.getCurrentPosition(resolve, reject, options))
        .then(({coords: {latitude, longitude}}) => ({lat: latitude, lng: longitude}));
}

/**
 * @template V
 * @param {V} value
 * @param {function(V): void} callback
 * @return {V}
 */
export function tap(value, callback) {
    callback(value);
    return value;
}
